import { render } from "./HeaderMenuItems.vue?vue&type=template&id=33459422"
import script from "./HeaderMenuItems.vue?vue&type=script&lang=js"
export * from "./HeaderMenuItems.vue?vue&type=script&lang=js"

import "./HeaderMenuItems.vue?vue&type=style&index=0&id=33459422&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__